<template>
  <div @keydown.stop>
    <textarea
      :id="name"
      ref="redactor"
      :name="name"
      :placeholder="placeholder"
      :value="value"
    />
  </div>
</template>

<script type="text/babel">
import Vue2 from 'vue/dist/vue.common.js'

require('../vendor/redactor/redactor.css')
require('../vendor/redactor/redactor.js')
require('../vendor/redactor/plugins/video/video.js')
require('../vendor/redactor/plugins/alignment/alignment')

export default {
  name: 'Redactor',
  redactor: false,
  props: {
    value: {
      type: String,
      required: false,
      default: '',
    },
    placeholder: {
      type: String,
      required: false,
      default: null,
    },
    name: {
      type: String,
      required: false,
      default: null,
    },
    config: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  computed: {
    mergedConfig() {
      return Object.assign({
        formatting: ['p', 'blockquote', 'h1', 'h2', 'h3', 'h4'],
        buttons: ['redo', 'undo', 'format', 'bold', 'italic', 'ul', 'ol', 'link', 'html', 'image'],
        imageUpload: this.$urlGenerator.active('api/v1/images/redactor'),
        imageUploadParam: 'images',
        linkNewTab: true,
        plugins: ['alignment'],
        minHeight: '300px',
      }, this.config)
    },
  },
  watch: {
    value(newValue) {
      if (!this.redactor.editor.isFocus() && !this.redactor.editor.isSourceMode()) {
        this.redactor.source.setCode(newValue)
      }
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      const me = this
      const callbacks = {
        changed(html) {
          me.handleInput(html)

          return html
        },
      }

      // extend config
      Vue2.set(this.mergedConfig, 'callbacks', callbacks)

      // call Redactor
      const app = $R(this.$refs.redactor, this.mergedConfig)

      // set instance
      this.redactor = app
      this.$parent.redactor = app
    },
    handleInput(val) {
      this.$emit('input', val)
    },
  },
}
</script>

<style type="scss">
.redactor-box.redactor-styles-on {
  border-radius: .25rem !important;
}

.redactor-toolbar {
  z-index: 19 !important;
}

.redactor-focus.redactor-styles-on,
.redactor-focus:focus.redactor-styles-on {
  border-color: #064bc3 !important;
  -webkit-box-shadow: 0 0 0 1px #064bc3;
  box-shadow: 0 0 0 1px #064bc3;
  outline: none
}
</style>
